const WhiteArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2.5rem" // Converted width from pixels to REM
      height="0.875rem" // Converted height from pixels to REM
      viewBox="0 0 62 10"
      style={{
        alignItems: "center",
        justifyContent: "center",
        margin: "auto 0",
      }}
      fill="none"
    >
      <path
        opacity="1"
        d="M61.0303 6.3067C61.3232 6.0138 61.3232 5.53893 61.0303 5.24604L56.2574 0.473066C55.9645 0.180173 55.4896 0.180173 55.1967 0.473066C54.9038 0.76596 54.9038 1.24083 55.1967 1.53373L59.4393 5.77637L55.1967 10.019C54.9038 10.3119 54.9038 10.7868 55.1967 11.0797C55.4896 11.3726 55.9645 11.3726 56.2574 11.0797L61.0303 6.3067ZM0.5 6.52637H60.5V5.02637H0.5V6.52637Z"
        fill="white"
        style={{
          alignItems: "center",
          justifyContent: "center",
          margin: "auto 0",
        }}
      />
    </svg>
  );
};
export default WhiteArrow;
